module.exports = __webpack_public_path__ + "img/content_bg3.0164ba8.png";